import React, {Component} from 'react';
import {Link} from 'react-router';

export default class Footer extends Component {
    constructor(){
        super();
        this.displayFaq = this.displayFaq.bind(this);
        this.displayFeaturedText = this.displayFeaturedText.bind(this);
    }

    displayFaq(){
        const {showFaq} = this.props;

        return showFaq ? (
            <span>
                <Link to="/faq">
                    Have questions? Visit our&nbsp;
                    <strong>FAQ</strong>
                </Link>
            </span>
        ) : null;
    }

    displayFeaturedText(){
        const {dontShowJobs, page} = this.props;

        return dontShowJobs ? null : (
            <span className='featured-by-text'>
                <strong>All images featured were created via Social Native</strong>
            </span>
        );
    }

    render() {
        const {children} = this.props;
        const faq = this.displayFaq();
        const featuredText = this.displayFeaturedText();

        return (
            <footer>
                {children && <div>{children}</div>}
                <div style={{clear: 'both'}}>
                    {featuredText}
                    {faq}
                </div>
                <div>
                    <span>
                        <Link to="/jobs">
                            <strong>JOIN US</strong>&nbsp;
                            View our JOBS
                        </Link>
                    </span>
                    <span>
                        <strong>VISIT US&nbsp;</strong>
                        9935 Santa Monica Blvd, Beverly Hills<span className="hide show-inline@sm">, CA 90212</span>
                    </span>
                    <span>
                        <a href="//instagram.com/social_native" target="_blank">
                            <strong>FOLLOW US&nbsp;</strong>
                            @social_native
                        </a>
                    </span>
                </div>
                <div>
                    <span className='footer-privacy-policy'>
                        <Link to="/privacy">
                            Privacy Policy
                        </Link>
                    </span>
                    <span className='footer-terms-of-use'>
                        <Link to="/terms">
                            Terms of Use
                        </Link>
                    </span>
                    <span>
                        <Link to="/content_creator">
                            Creators
                        </Link>
                    </span>
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/footer.js